import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCartIcon, CreditCardIcon, CheckIcon, XIcon, ArrowLeftIcon, ArrowRightIcon, AlertCircleIcon, InfoIcon, PhoneIcon } from 'lucide-react';
const Checkout = () => {
  const [step, setStep] = useState(1);
  const [paymentMethod, setPaymentMethod] = useState('mpesa');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const cartItems = [{
    id: '1',
    name: 'Venture Wars',
    type: 'Event Ticket - Regular',
    price: 1500,
    quantity: 1
  }, {
    id: '2',
    name: 'Yoga In The Park',
    type: 'Event Ticket - VIP',
    price: 800,
    quantity: 2
  }];
  const subtotal = cartItems.reduce((total, item) => total + item.price * item.quantity, 0);
  const fees = 120;
  const total = subtotal + fees;
  const handleNextStep = () => {
    if (step < 3) {
      setStep(step + 1);
    }
  };
  const handlePrevStep = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };
  const handlePayment = () => {
    if (!phoneNumber) {
      setErrorMessage('Please enter your phone number');
      return;
    }
    // Validate phone number format
    if (!/^(07|01)\d{8}$|^(254|0)\d{9}$/.test(phoneNumber)) {
      setErrorMessage('Please enter a valid M-Pesa phone number');
      return;
    }
    setErrorMessage('');
    setIsProcessing(true);
    // Simulate payment processing
    setTimeout(() => {
      setIsProcessing(false);
      setIsComplete(true);
    }, 3000);
  };
  return <div className="pb-16" data-id="element-956">
      <div className="border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800" data-id="element-957">
        <div className="max-w-4xl mx-auto p-4" data-id="element-958">
          <h1 className="text-2xl font-bold mb-2 flex items-center" data-id="element-959">
            <ShoppingCartIcon className="w-6 h-6 mr-2" data-id="element-960" />
            Checkout
          </h1>
          {!isComplete && <div className="flex items-center text-sm text-gray-600 dark:text-gray-300" data-id="element-961">
              <div className={`flex items-center ${step >= 1 ? 'text-gray-800 dark:text-gray-200 font-medium' : ''}`} data-id="element-962">
                <span className={`w-5 h-5 rounded-full flex items-center justify-center mr-1 ${step >= 1 ? 'bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800' : 'bg-gray-200 dark:bg-gray-700'}`} data-id="element-963">
                  1
                </span>
                <span data-id="element-964">Cart</span>
              </div>
              <span className="mx-2 text-gray-400" data-id="element-965">→</span>
              <div className={`flex items-center ${step >= 2 ? 'text-gray-800 dark:text-gray-200 font-medium' : ''}`} data-id="element-966">
                <span className={`w-5 h-5 rounded-full flex items-center justify-center mr-1 ${step >= 2 ? 'bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800' : 'bg-gray-200 dark:bg-gray-700'}`} data-id="element-967">
                  2
                </span>
                <span data-id="element-968">Payment</span>
              </div>
              <span className="mx-2 text-gray-400" data-id="element-969">→</span>
              <div className={`flex items-center ${step >= 3 ? 'text-gray-800 dark:text-gray-200 font-medium' : ''}`} data-id="element-970">
                <span className={`w-5 h-5 rounded-full flex items-center justify-center mr-1 ${step >= 3 ? 'bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800' : 'bg-gray-200 dark:bg-gray-700'}`} data-id="element-971">
                  3
                </span>
                <span data-id="element-972">Confirmation</span>
              </div>
            </div>}
        </div>
      </div>
      <div className="max-w-4xl mx-auto p-4" data-id="element-973">
        {isComplete ? <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6 text-center" data-id="element-974">
            <div className="w-16 h-16 bg-gray-100 dark:bg-gray-700 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-975">
              <CheckIcon className="w-8 h-8 text-gray-800 dark:text-gray-200" data-id="element-976" />
            </div>
            <h2 className="text-xl font-bold mb-2" data-id="element-977">Payment Successful!</h2>
            <p className="text-sm text-gray-600 dark:text-gray-300 mb-6" data-id="element-978">
              Thank you for your purchase. Your tickets are now available in
              your account.
            </p>
            <div className="flex justify-center space-x-4" data-id="element-979">
              <Link to="/tickets" className="px-4 py-2 bg-gray-800 text-white dark:bg-gray-200 dark:text-gray-800 rounded-md" data-id="element-980">
                View My Tickets
              </Link>
              <Link to="/" className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md" data-id="element-981">
                Return to Home
              </Link>
            </div>
          </div> : <>
            {step === 1 && <div className="mb-6" data-id="element-982">
                <h2 className="text-lg font-bold mb-4" data-id="element-983">Your Cart</h2>
                <div className="border border-gray-300 dark:border-gray-600 rounded-lg overflow-hidden mb-4" data-id="element-984">
                  <div className="bg-gray-100 dark:bg-gray-700 p-3 border-b border-gray-300 dark:border-gray-600 grid grid-cols-12 gap-2" data-id="element-985">
                    <div className="col-span-6 font-medium text-sm" data-id="element-986">Item</div>
                    <div className="col-span-2 font-medium text-sm text-center" data-id="element-987">
                      Price
                    </div>
                    <div className="col-span-2 font-medium text-sm text-center" data-id="element-988">
                      Qty
                    </div>
                    <div className="col-span-2 font-medium text-sm text-right" data-id="element-989">
                      Total
                    </div>
                  </div>
                  <div className="divide-y divide-gray-200 dark:divide-gray-700" data-id="element-990">
                    {cartItems.map(item => <div key={item.id} className="p-3 grid grid-cols-12 gap-2 items-center" data-id="element-991">
                        <div className="col-span-6" data-id="element-992">
                          <div className="font-medium" data-id="element-993">{item.name}</div>
                          <div className="text-xs text-gray-500" data-id="element-994">
                            {item.type}
                          </div>
                        </div>
                        <div className="col-span-2 text-sm text-center" data-id="element-995">
                          KES {item.price.toLocaleString()}
                        </div>
                        <div className="col-span-2 text-sm text-center" data-id="element-996">
                          {item.quantity}
                        </div>
                        <div className="col-span-2 text-sm text-right font-medium" data-id="element-997">
                          KES {(item.price * item.quantity).toLocaleString()}
                        </div>
                      </div>)}
                  </div>
                </div>
                <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4 mb-6" data-id="element-998">
                  <div className="flex justify-between mb-2" data-id="element-999">
                    <span className="text-sm" data-id="element-1000">Subtotal</span>
                    <span className="font-medium" data-id="element-1001">
                      KES {subtotal.toLocaleString()}
                    </span>
                  </div>
                  <div className="flex justify-between mb-2" data-id="element-1002">
                    <span className="text-sm" data-id="element-1003">Service Fee</span>
                    <span className="font-medium" data-id="element-1004">
                      KES {fees.toLocaleString()}
                    </span>
                  </div>
                  <div className="border-t border-gray-200 dark:border-gray-700 my-2 pt-2" data-id="element-1005">
                    <div className="flex justify-between" data-id="element-1006">
                      <span className="font-bold" data-id="element-1007">Total</span>
                      <span className="font-bold" data-id="element-1008">
                        KES {total.toLocaleString()}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="flex justify-between" data-id="element-1009">
                  <Link to="/tickets" className="flex items-center text-sm" data-id="element-1010">
                    <ArrowLeftIcon className="w-3 h-3 mr-1" data-id="element-1011" />
                    Continue Shopping
                  </Link>
                  <button onClick={handleNextStep} className="px-4 py-2 bg-gray-800 text-white dark:bg-gray-200 dark:text-gray-800 rounded-md" data-id="element-1012">
                    Proceed to Payment
                  </button>
                </div>
              </div>}
            {step === 2 && <div className="mb-6" data-id="element-1013">
                <h2 className="text-lg font-bold mb-4" data-id="element-1014">Payment Method</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1015">
                  <div className="space-y-4" data-id="element-1016">
                    <div className={`border ${paymentMethod === 'mpesa' ? 'border-gray-800 dark:border-gray-200' : 'border-gray-300 dark:border-gray-600'} rounded-lg p-4 cursor-pointer`} onClick={() => setPaymentMethod('mpesa')} data-id="element-1017">
                      <div className="flex items-center" data-id="element-1018">
                        <div className="w-5 h-5 border-2 rounded-full flex items-center justify-center mr-3 border-gray-800 dark:border-gray-200" data-id="element-1019">
                          {paymentMethod === 'mpesa' && <div className="w-3 h-3 bg-gray-800 dark:bg-gray-200 rounded-full" data-id="element-1020"></div>}
                        </div>
                        <div data-id="element-1021">
                          <h3 className="font-medium" data-id="element-1022">M-Pesa</h3>
                          <p className="text-xs text-gray-500" data-id="element-1023">
                            Pay directly with your M-Pesa account
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className={`border ${paymentMethod === 'card' ? 'border-gray-800 dark:border-gray-200' : 'border-gray-300 dark:border-gray-600'} rounded-lg p-4 cursor-pointer`} onClick={() => setPaymentMethod('card')} data-id="element-1024">
                      <div className="flex items-center" data-id="element-1025">
                        <div className="w-5 h-5 border-2 rounded-full flex items-center justify-center mr-3 border-gray-800 dark:border-gray-200" data-id="element-1026">
                          {paymentMethod === 'card' && <div className="w-3 h-3 bg-gray-800 dark:bg-gray-200 rounded-full" data-id="element-1027"></div>}
                        </div>
                        <div data-id="element-1028">
                          <h3 className="font-medium" data-id="element-1029">Card Payment</h3>
                          <p className="text-xs text-gray-500" data-id="element-1030">
                            Pay with debit or credit card
                          </p>
                        </div>
                      </div>
                    </div>
                    {paymentMethod === 'mpesa' && <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4" data-id="element-1031">
                        <h3 className="font-medium mb-3" data-id="element-1032">
                          Enter M-Pesa Number
                        </h3>
                        <div className="mb-4" data-id="element-1033">
                          <div className="flex items-center mb-1" data-id="element-1034">
                            <PhoneIcon className="w-4 h-4 mr-1" data-id="element-1035" />
                            <label htmlFor="phone" className="text-sm" data-id="element-1036">
                              Phone Number
                            </label>
                          </div>
                          <input type="tel" id="phone" placeholder="e.g. 07XX XXX XXX" className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md" value={phoneNumber} onChange={e => setPhoneNumber(e.target.value)} data-id="element-1037" />
                          <p className="text-xs text-gray-500 mt-1" data-id="element-1038">
                            Enter the phone number registered with M-Pesa
                          </p>
                        </div>
                        {errorMessage && <div className="bg-red-50 dark:bg-red-900/20 text-red-800 dark:text-red-200 p-2 rounded-md text-sm flex items-start mb-4" data-id="element-1039">
                            <AlertCircleIcon className="w-4 h-4 mr-1 flex-shrink-0 mt-0.5" data-id="element-1040" />
                            <span data-id="element-1041">{errorMessage}</span>
                          </div>}
                        <div className="bg-gray-50 dark:bg-gray-700 p-3 rounded-md text-xs text-gray-600 dark:text-gray-300 flex items-start" data-id="element-1042">
                          <InfoIcon className="w-4 h-4 mr-1 flex-shrink-0 mt-0.5" data-id="element-1043" />
                          <span data-id="element-1044">
                            You will receive an M-Pesa prompt on your phone to
                            complete the payment. Please enter your M-Pesa PIN
                            when prompted.
                          </span>
                        </div>
                      </div>}
                    {paymentMethod === 'card' && <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4" data-id="element-1045">
                        <h3 className="font-medium mb-3" data-id="element-1046">Card Details</h3>
                        <div className="mb-3" data-id="element-1047">
                          <label htmlFor="cardNumber" className="block text-sm mb-1" data-id="element-1048">
                            Card Number
                          </label>
                          <input type="text" id="cardNumber" placeholder="XXXX XXXX XXXX XXXX" className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md" data-id="element-1049" />
                        </div>
                        <div className="grid grid-cols-2 gap-3 mb-3" data-id="element-1050">
                          <div data-id="element-1051">
                            <label htmlFor="expiry" className="block text-sm mb-1" data-id="element-1052">
                              Expiry Date
                            </label>
                            <input type="text" id="expiry" placeholder="MM/YY" className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md" data-id="element-1053" />
                          </div>
                          <div data-id="element-1054">
                            <label htmlFor="cvv" className="block text-sm mb-1" data-id="element-1055">
                              CVV
                            </label>
                            <input type="text" id="cvv" placeholder="XXX" className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md" data-id="element-1056" />
                          </div>
                        </div>
                        <div className="mb-3" data-id="element-1057">
                          <label htmlFor="name" className="block text-sm mb-1" data-id="element-1058">
                            Name on Card
                          </label>
                          <input type="text" id="name" placeholder="John Doe" className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md" data-id="element-1059" />
                        </div>
                      </div>}
                  </div>
                  <div data-id="element-1060">
                    <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4 mb-4" data-id="element-1061">
                      <h3 className="font-medium mb-3" data-id="element-1062">Order Summary</h3>
                      <div className="space-y-2 mb-3" data-id="element-1063">
                        {cartItems.map(item => <div key={item.id} className="flex justify-between text-sm" data-id="element-1064">
                            <span data-id="element-1065">
                              {item.name} x{item.quantity}
                            </span>
                            <span data-id="element-1066">
                              KES{' '}
                              {(item.price * item.quantity).toLocaleString()}
                            </span>
                          </div>)}
                      </div>
                      <div className="border-t border-gray-200 dark:border-gray-700 pt-2 mb-2" data-id="element-1067">
                        <div className="flex justify-between text-sm" data-id="element-1068">
                          <span data-id="element-1069">Subtotal</span>
                          <span data-id="element-1070">KES {subtotal.toLocaleString()}</span>
                        </div>
                        <div className="flex justify-between text-sm" data-id="element-1071">
                          <span data-id="element-1072">Service Fee</span>
                          <span data-id="element-1073">KES {fees.toLocaleString()}</span>
                        </div>
                      </div>
                      <div className="border-t border-gray-200 dark:border-gray-700 pt-2" data-id="element-1074">
                        <div className="flex justify-between font-bold" data-id="element-1075">
                          <span data-id="element-1076">Total</span>
                          <span data-id="element-1077">KES {total.toLocaleString()}</span>
                        </div>
                      </div>
                    </div>
                    <div className="bg-gray-50 dark:bg-gray-700 p-3 rounded-md text-xs text-gray-600 dark:text-gray-300 mb-4" data-id="element-1078">
                      By proceeding with the payment, you agree to our{' '}
                      <Link to="/terms" className="underline" data-id="element-1079">
                        Terms of Service
                      </Link>{' '}
                      and{' '}
                      <Link to="/refund" className="underline" data-id="element-1080">
                        Refund Policy
                      </Link>
                      .
                    </div>
                  </div>
                </div>
                <div className="flex justify-between mt-6" data-id="element-1081">
                  <button onClick={handlePrevStep} className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md" data-id="element-1082">
                    Back to Cart
                  </button>
                  <button onClick={handlePayment} disabled={isProcessing} className="px-4 py-2 bg-gray-800 text-white dark:bg-gray-200 dark:text-gray-800 rounded-md flex items-center" data-id="element-1083">
                    {isProcessing ? <>
                        <div className="animate-spin w-4 h-4 border-2 border-white dark:border-gray-800 border-t-transparent dark:border-t-transparent rounded-full mr-2" data-id="element-1084"></div>
                        Processing...
                      </> : <>Pay KES {total.toLocaleString()}</>}
                  </button>
                </div>
              </div>}
          </>}
      </div>
    </div>;
};
export default Checkout;